import * as DialogPrimitive from '@radix-ui/react-dialog'
import { cn } from '@core/utils'

const DialogDescription = ({
    className,
    ...props
}: React.ComponentProps<typeof DialogPrimitive.Description>) => {
    return (
        <DialogPrimitive.Description
            data-slot="dialog-description"
            className={cn('text-muted-foreground text-sm', className)}
            {...props}
        />
    )
}

DialogDescription.displayName = 'DialogDescription'

export default DialogDescription
